<template>
  <div class="viewer_holder w-100">
    <div v-if="activeLeftNav !== 'payment'">
      <div     v-if="Object.keys( this.$store.state.currentFloorplan).length > 0">
        <img :src="currentFloorplan.gallery[0]" alt="" class="img-fluid m-auto" style="height: 100%; padding: 35px">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "floorplan_viewer",
  watch: {},
  computed: {
    activeLeftNav() {
      return this.$store.state.activeLeftNav
    },
    currentFloorplan(){
      return this.$store.state.currentFloorplan
    }

  },
  methods: {},
  created() {
  }
}
</script>

<style scoped lang="scss">
#klarna-checkout-iframe body{
  background: #F8F8F8!important;
}
.viewer_holder {
  background: #F8F8F8;
  text-align: center;
  flex: 1;
  position: relative;
  border-left: 1px solid #EDEDED;

  .viewer_holder_guid {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 8px 6px;
    gap: 15px;
    top: 17px;
    right: 20px;
    background: #ECEFF0;
    border-radius: 68px;

    .viewer_holder_guid_iconholder {
      &.active {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
        border-radius: 50%;
      }
    }

    i {
      font-size: 20px;
    }
  }
}


</style>
